module.exports = __webpack_public_path__ + "img/charging-hub-realized-semipublic.3b10c8eb.svg";